import { createAction } from 'redux-actions';

export const HIDE_MODAL = 'HIDE_MODAL';

export default createAction(HIDE_MODAL);
